export default {
  data() {
    return {
      statsPresets: []
    };
  },

  created() {
    const allowedTabs = [
      {
        id: 6,
        name: "STATS",
        alias: "STATS",
        presetTab: false
      }
    ];

    if (this.CheckUserPermission([1, 2])) {
      this.statsPresets = [...this.statsPresets, ...allowedTabs];
    }
  }
};
